import {
  type ClientNotifications,
  type ClientReminders,
  type NotificationType,
  type OwnerNotifications,
  type TrainerNotifications,
} from "@fitness-app/data-models/entities/Notification";

import { type RequestStatus } from "../../../enums/requestStatus";

export const NOTIFICATIONS_REDUCER_NAME = "notifications";

export enum NotificationAction {
  MarkAsRead = "MARK_AS_READ",
}

export interface NotificationsReducer {
  notifications: (ClientNotifications | OwnerNotifications | TrainerNotifications | ClientReminders)[];
  listStatus: null | RequestStatus;
  totalUnread: number;
  filter: "all" | "unread";
  // The type filter the list was last read with. `totalUnread` is counted with the very same
  // filter, so the badge can never advertise a notification the list is not allowed to show
  // (TRE-1952; TRE-1840 and friends kept patching that mismatch one notification type at a time).
  typeFilter: NotificationType[];
  performingAction: null | {
    action: NotificationAction;
    notificationId?: string;
  };
  page: number;
  pageSize: number;
  hasMore: boolean;
}
